
import {
  Grid,
  Row,
  Col,
  Image,
  Button,
  Navbar,
}from 'react-bootstrap';

import {
  Route,
}from 'react-router-dom';

import {
  LinkContainer,
}from 'react-router-bootstrap';

import {
  PresentationAct,
  DictationAct,
  WordSearchAct,
  IdentifyAct,
  TestAct,
  AnalyzeAct,
  Progress,
}from './';

import {
  COLOR,
  MODES,
}from '../const';

var React = require('react');
var PropTypes = require('prop-types');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');

var PresIcon = require('../img/PresIcon.svg');
var DictIcon = require('../img/DictIcon.svg');
var AnalyzeIcon = require('../img/AnalyzeIcon.svg');
var IdenitfyIcon = require('../img/IdentifyIcon.svg');
var TestIcon = require('../img/TestIcon.svg');
var WordSearchIcon = require('../img/WordSearchIcon.svg');

class ActWrapper extends React.Component {

  getProgressVal = () => {
    const length = this.props.progressList.length;

    let progress = 0;

    const {progressList} = this.props;

    for(let item in this.props.progressList){
      if(progressList[item].wasChecked ){
        progress++;
      }
    }

    return (progress / length) * 100;
  }

  getScore = () => {
    const length = this.props.progressList.length;

    let score = 0;

    const {progressList} = this.props;

    for(let item in this.props.progressList){
      if(progressList[item].wasChecked && progressList[item].isCorrect ){
        score++;
      }
    }

    return (score / length) * 100;
  }

  render() {

    const { initializeAct, inActivity, updateCompletedActs, mode} = this.props;

    const progressVal = this.getProgressVal();
    const scoreVal = this.getScore();

    let isComplete = (progressVal === 100) ? true : false;

    return(
      <div>
      <Grid>
        <ActHeading heading={this.props.mode.heading}/>
        {/* If not in activity show menu */}

        <Route path={`/${this.props.match.params.pid}`} exact render={props => (
          <ActMenu
            initializeAct={initializeAct}
            {...this.props}
          />
        )}/>


        <ActItem {...this.props} />

        {inActivity && !isComplete &&
          <Navbar fixedBottom fluid style={styles.progressNavBar}>
            <Progress
              progressList = {this.props.progressList}
            />
          </Navbar>
        }
        {inActivity && isComplete &&
          <Navbar fixedBottom fluid style={styles.progressNavBar}>
            <Button bsStyle="success" block onClick={() => updateCompletedActs(mode.name, scoreVal)}>
              Complete!
            </Button>
          </Navbar>
        }
      </Grid>
      </div>
    )
  }
}

let ActHeading = ({heading = "Select an activity below to get started:"}) => {
  return(
    <Row>
      <Col xs={12}>
        <h3 style={styles.actHeading}>{heading}</h3>
      </Col>
    </Row>
  )
}

let ActMenu = (props) => {
  return(
    <Row>
      <MenuItem
        title="Presentation"
        img={PresIcon}
        completed={props.completedActs.Presentation.completed}
        score={props.completedActs.Presentation.score}
        id={MODES.Presentation}
        onClick={props.initializeAct}
        match={props.match}
      />
      <MenuItem
        title="Identify"
        img={IdenitfyIcon}
        completed={props.completedActs.Identify.completed}
        score={props.completedActs.Identify.score}
        id={MODES.Identify}
        onClick={props.initializeAct}
        match={props.match}
      />
      <MenuItem
        title="Word Search"
        img={WordSearchIcon}
        completed={props.completedActs.WordSearch.completed}
        score={props.completedActs.WordSearch.score}
        id={MODES.WordSearch}
        onClick={props.initializeAct}
        match={props.match}
      />
      <MenuItem
        title="Analyze"
        img={AnalyzeIcon}
        completed={props.completedActs.Analyze.completed}
        score={props.completedActs.Analyze.score}
        id={MODES.Analyze}
        onClick={props.initializeAct}
        match={props.match}
      />
      <MenuItem
        title="Dictation"
        img={DictIcon}
        completed={props.completedActs.Dictation.completed}
        score={props.completedActs.Dictation.score}
        id={MODES.Dictation}
        onClick={props.initializeAct}
        match={props.match}
      />
      <MenuItem
        title="Test"
        img={TestIcon}
        completed={props.completedActs.Test.completed}
        score={props.completedActs.Test.score}
        id={MODES.Test}
        onClick={props.initializeAct}
        match={props.match}
        xs={8}
        xsOffset={2}
        md={3}
      />
    </Row>
  )
}

let MenuItem = ({xs = 8, xsOffset = 2,sm = 4, smOffset = 4, md = 3, mdOffset = 1, lg = 3, lgOffset = 0, xl, xlOffset, completed, score, match, id, onClick, title, img}) => (
  <Col xs={xs} xsOffset={xsOffset} sm={sm} smOffset={smOffset} md={md} mdOffset={mdOffset} lg={lg} lgOffset={lgOffset}>
    <div style={styles.menuItem}>
      <h3 style={styles.menuItem.base.title}>{title}</h3>
      <Image src={img} style={styles.menuItem.base.logo} />
      <div style={styles.menuItem.base.content}>
        <div style={styles.menuItem.base.content.completed}>
          <i>Completed:</i>&nbsp;&nbsp;
          <DoneIcon
            completed={completed}
            size="lg"
          />
          <div>Score: {score}%</div>
        </div>
        <LinkContainer to={`${match.params.pid}/${id.action}`}>
          <Button
            bsSize="large"
            bsStyle="success"
            style={styles.menuItem.base.content.button}
            onClick={()=> onClick(id)}
          >
            Start &nbsp;
            <FontAwesome
              name="play"
              inverse={true}
            />
          </Button>
        </LinkContainer>
      </div>
    </div>
  </Col>
)

let ActItem = (props) => (
  <div>
  <Route
    path={`/:pid/${MODES.Presentation.action}`}
    render={prop => (

      <PresentationAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.Dictation.action}`}
    render={prop => (
      <DictationAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.Analyze.action}`}
    render={prop => (
      <AnalyzeAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.AlphabeticalOrder.action}`}
    render={prop => (
      <PresentationAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.Identify.action}`}
    render={prop => (
      <IdentifyAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.WordSearch.action}`}
    render={prop => (
      <WordSearchAct {...props} />
    )}
  />
  <Route
    path={`/:pid/${MODES.Test.action}`}
    render={prop => (
      <TestAct {...props} />
    )}
  />
  </div>
)

const DoneIcon = ({completed = false, size = "lg"}) => (
  <FontAwesome
    name={(completed) ? "check" : "times"}
    size={size}
    inverse={true}
  />
)

/* --------------------------- RADIUM WRAPPERS --------------------------- */

ActHeading = Radium(ActHeading);

MenuItem = Radium(MenuItem);

/* ---------------------------     STLYES      --------------------------- */

const styles= {
  actHeading: {
    color: COLOR.grayDark,
    padding: '3rem 2rem'
  },
  menuItem: {
    width: '100%',
    height: '42rem',
    marginBottom: '3rem',
    borderRadius: '1rem',
    textAlign: 'center',
    backgroundColor: COLOR.blue,
    color: COLOR.white,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'column',

    base: {
      logo: {
        width: '15rem',
        height: '15rem',
        borderRadius: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
      },

      title: {
        paddingTop: '2rem',
        paddingBottom: '2rem',
      },

      content: {
        marginTop: '1.5rem',
        width: '100%',

        completed:{
          padding: '2rem 0rem',
          fontSize: '19px',
        },

        button: {
          width: '80%',
          marginTop: '2rem',
          marginLeft: '2rem',
          marginRight: '2rem',
        },
      },
    },
  },
  progressNavBar: {
    height: '60px',
    minHeight: '30px',
  }

}

/* ---------------------------    PROPTYPES    --------------------------- */

ActWrapper.propTypes = {
  initializeAct: PropTypes.func,
}

ActMenu.propTypes = {
  initializeAct: PropTypes.func,
}

/* ---------------------------     EXPORTS    --------------------------- */

export default Radium(ActWrapper);



// WEBPACK FOOTER //
// ./src/comp/ActWrapper.js